import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTopButton, { ScrollToTopOnMount } from "./ScrollToTop";

interface LayoutProps {
  children: ReactNode;
  withPadding?: boolean;
}

const Layout = ({ children, withPadding = true }: LayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTopOnMount />
      <Navbar />
      <main className={`flex-grow ${withPadding ? 'pt-20' : ''}`}>
        {children}
      </main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
};

export default Layout;